import round from 'lodash/round'
export const LICENSE_SERIES = (typex, typey) => {
  return {
    licensesTrend: [{
      type: 'bar',
      encode: {
        x: typex === '1' ? 'time' : (typex === '2' ? 'type' : 'district'),
        y: typey === '1' ? 'licenses' : (typey === '2' ? 'customers' : 'applicants')
      },
      barMaxWidth: 14
    }]
  }
}
//y  1 :licenses  2:customers 3:applicants
export const INDICATORS =  {
    '1': {
      field: 'licenses',
      name: '新开License数量',
      bit: 2,
      unit: '个'
    },
    '2':{
      field: 'customers',
      name: '新增客户数量',
      unit: '个'
    },
    '3':{
      field: 'applicants',
      name: '申请License人数',
      unit: '个'
    }
  }
export const lengthName =  {
    active: '已激活',
    unActive: '未激活',
    formal:'正式',
    poc:'POC',
    trial: '试用',
    subs:'订阅式',
    unSubs:'买断式',
    expired:'已过期',
    toExpire:'即将过期',
    unExpired:'时间充足',
    service: '服务',
    delivery: '交付',
    renewal: '续约',
    test: '测试'
}
export const toolName =  {
  '1': 'License状态',
  '2': '阶段',
  // '3': '购买模式',
  '4': '有效期剩余',
  "5": 'License类型'
}

const legendFormatter = function (name) {
  return lengthName[name]
}
let legendFormatterToltip = function (name) {
  return lengthName[name.name]
}

export const innerData = (dt, name, value)=> {
  let arr = []
  let namrArr = []
  let total = 0
  for (let i = 0; i < dt.length; i++) {
    if (name == 'inLabel') {
      let name1 = dt[i][name]
      let trueOrFalse = 'false'
      namrArr.forEach((item) => {
        // 去重操作
        if (item == name1) {
          trueOrFalse = 'true'
          return false
        }
      })
      if (trueOrFalse == 'false') {
        let _json = {
          value: dt[i][value],
          name: dt[i][name],
          // dt[i][value]:dt[i][name]
        }
        arr.push(_json)
        namrArr.push(dt[i][name])
      }
    } else {
      let _json = {
        value: dt[i][value],
        name: dt[i][name],
        total: dt[i]['outTotal'],
        itemStyle: {
          color: colors(dt[i][name])
        }
      }
      // total = total + Number(dt[i][value])
      arr.push(_json)
    }
  }
  return arr
}
export const colors = (type)=>{
  // ['#0273FF', '#4D9DFF','#9AC7FF']
  if(type==="unExpired" || type==="active" || type==="formal" || type==="subs"){
    return '#0273FF'
  }else if(type==="expired" || type==="unActive" || type==="poc" || type==="unSubs"){
    return '#4D9DFF'
  }else if(type==="toExpire"){
    return '#9AC7FF'
  }
}


export const makeData = (typeDate, name, brandData,inName,color,color1)=> {
  return {
    // color: color,
    tooltip: {
      trigger: 'item',
      // formatter: '{a} <br/>{b}: {c} ({d}%)',
      formatter: val=>{
        let str = ''
        str += val.seriesName + '<br/>' + lengthName[val.name] + '：' +val.value + ' (' + val.percent + ')%'
        if(val.seriesIndex === 1){
          let value = round(val.value*100/val.percent)
          str += '<br/>' + '全部' + lengthName[val.name] + '：' +val.data.total + ' (' + round(val.data.total*100/value,2) + ')%'
        }
        return str
      }
    },
    legend: {
      orient: 'horizontal', // 图片左侧对应的小提示  水平分布
      x: '250', // 图片左侧对应的小提示  靠着右侧分布
      y: 'center',
      icon: 'circle',
      itemWidth: 12, // 图例图形宽度
      itemHeight: 12,
      itemGap: 56,
      textStyle: {
        color: '#4e4e4e' // 图例文字颜色
      },
      formatter: legendFormatter,
      tooltip: {
        show: true,
        formatter: legendFormatterToltip
      },
    },
    series: [
      {
        minAngle: 10,
        color: ['#01A63D', '#4DC077', '#99DBB1'],
        name: toolName[name],
        type: 'pie',
        selectedMode: 'single',
        center: ['10%', '50%'],
        radius: [0, '40%'],
        label: {
          normal: {
            //   position: 'inner',
            show: false
          }
        },
        itemStyle: {
          borderWidth: 2, // 设置border的宽度有多大
          borderColor: '#fff'
        },
        labelLine: {
          normal: {
            show: false // 内层饼图的箭头指示线和指示框  不显示
          },
        },
        data: typeDate // 内层饼图的数据来源
      },
       ...(brandData.length > 0 ? [
        {
          minAngle: 6,
          color: ['#0273FF', '#4D9DFF','#9AC7FF'],
          name: toolName[inName],
          type: 'pie',
          center: ['10%', '50%'],
          radius: ['50%', '70%'],
          itemStyle: {
            borderWidth: 2, // 设置border的宽度有多大
            borderColor: '#fff'
          },
          label: {
            normal: {
              show: false // 外层饼图的箭头指示线和指示框  不显示
            },
            formatter: val => {
              return val
            }
          },
          data: brandData // 外层饼图的数据来源
        }
      ] : []),
      
    ]
  }
}